import React, { useEffect, useState } from "react";
import { useIds } from "../../hook/AdminContext";
import { useLocation } from "react-router-dom";
import { show_proper_words } from "../../utils/Constant";
import RecordNotFound2 from "../../components/recordNotFound/SataNitFound";
import PageLoading from "../../components/loader/PageLoading";
import FeedSkeletonLoader from "../../components/loader/Feedskeltonloader";
import { Tab, Tabs } from "@mui/material";
import JobPostList from "../post/JobPostList";
import FeedListing from "../post/FeedListing";

export default function HomePage() {
  const { userInfo } = useIds();
  const [showInfoBox, setShowInfoBox] = useState(false);
  const [previewLink, setPreviewLink] = useState(true);
  const { setBreadCrumb, jobloader } = useIds();
  const location = useLocation();
  const firstSegment = location.pathname.split("/")[1];
  const [loading, setLoading] = useState(true);
  const queryParams = new URLSearchParams(location.search);
  const feedId = queryParams.get("feed_id");
  const [selectedTab, setSelectedTab] = useState(feedId ? "feeds" : "jobs");
  const isMobile = window.innerWidth <= 768;

  const get_sticky_value = () => {
    const height = document.querySelector(".right-side-bar")?.clientHeight;
    const vh = window.innerHeight;
    const final = -1 * vh * 1.1;

    if (vh > height) {
      return 0;
    }

    return final;
  };

  useEffect(() => {
    if (firstSegment !== "home") {
      setBreadCrumb([
        {
          name: `${show_proper_words(firstSegment)}`,
          path: `/${firstSegment}/home`,
          active: true,
        },
      ]);
    } else {
      setBreadCrumb([]);
    }
  }, [firstSegment]);

  const getHTMLForNoAccessMessage = () => {
    if (userInfo.role == "internal_user") {
      return `<h2>You have pending invitations.</h2>
      <p>Please visit your Invitations section to review and accept them.</p>
      <p>Accepting an invitation will grant you access to your company’s portal and assigned permissions.</p>
      <p>If you decline an invitation, your account will be removed from the company’s portal.</p>
      `;
    }

    let str = `<h2>No Access to Any Sources</h2>
<p>Your account currently has no access to any source.</p>
<p>You may have pending company invitations — please check your Invitations section to review and accept them.</p>
<p>If you already have access under another company, you can switch users to view that company’s profile with the permissions provided.</p>`;

    if (userInfo.role == "client") {
      str =
        str +
        "<p>To gain access under your own company account, please purchase a plan from our website to enable full access.</p>";
    }

    return str;
  };

  if (Array.isArray(userInfo?.navbar) && userInfo?.navbar.length === 0) {
    return (
      <div className="col-12 text-center">
        <RecordNotFound2
          html={getHTMLForNoAccessMessage()}
          showBackButton={false}
        />
      </div>
    );
  }

  return (
    <>
      {isMobile ? (
        <>
          <div className="d-flex justify-content-around my-2 mx-3">
            <Tabs
              value={selectedTab}
              onChange={(e, newValue) => setSelectedTab(newValue)}
              variant="fullWidth"
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab label="Feeds" value="feeds" />
              <Tab label="Jobs" value="jobs" />
            </Tabs>
          </div>

          <div className="container" style={{ maxWidth: "100%" }}>
            {selectedTab === "feeds" ? (
              <FeedListing
                showInfoBox={showInfoBox}
                setShowInfoBox={setShowInfoBox}
                userInfo={userInfo}
                previewLink={previewLink}
                setPreviewLink={setPreviewLink}
              />
            ) : (
              <JobPostList loading={loading} setLoading={setLoading} />
            )}
          </div>
        </>
      ) : (
        <>
          <div
            className="feed-section-wrapper container hide-scrollbar overflow-auto"
            // zoom effect change
            style={{ maxWidth: "660px" }}
          >
            {/* {loading ? (
              <FeedSkeletonLoader />
            ) : ( */}
            <div className="groupsFeeds">
              <FeedListing
                showInfoBox={showInfoBox}
                setShowInfoBox={setShowInfoBox}
                userInfo={userInfo}
                previewLink={previewLink}
                setPreviewLink={setPreviewLink}
              />
            </div>
            {/* // )} */}
          </div>
          <div
            className="right-side-bar no-scrollbar"
            style={{ top: get_sticky_value() }}
          >
            <JobPostList loading={loading} setLoading={setLoading} />
          </div>
        </>
      )}
    </>
  );
}
